import React, { memo } from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import allItemsOutOfStock from 'utilities/sku/isAllOptionsOutOfStock';
import { StockCode } from 'types/ProductResponseType';
import styles from './StockMessageDisplay.module.css';

const getStockMessageColour = (code: StockCode): string => {
  switch (code) {
    case StockCode.OUTOFSTOCK:
    case StockCode.UNAVAILABLE:
      return 'var(--color-universal-redMid)';
    case StockCode.DCSTOCK:
    case StockCode.DDSTOCK:
    case StockCode.DDSTOCKWORKINGDAYS:
    case StockCode.DDSTOCKWEEK:
    case StockCode.DDSTOCKDATE:
    case StockCode.DDSTOCKNEXTDATE:
      return 'var(--color-universal-greenMid)';
    default:
      return 'var(--color-universal-bronzeMid)';
  }
};

const getToneClassName = (code: StockCode): string => {
  const colour = getStockMessageColour(code);
  switch (colour) {
    case 'var(--color-universal-redMid)':
      return styles.toneRed;
    case 'var(--color-universal-greenMid)':
      return styles.toneGreen;
    default:
      return styles.toneBronze;
  }
};

const StockMessageDisplay = memo(() => {
  const { selectedSku, skus } = useSelectedSkuContext();
  const isEachItemOutOfStock = allItemsOutOfStock(skus);

  if (isEachItemOutOfStock) {
    return (
      <div data-testid="stock-message">
        <p
          className={[
            'fs-1 tvg-typography fv-heading fuse-typography-element',
            getToneClassName(StockCode.OUTOFSTOCK),
          ].join(' ')}
        >
          {skus[0]?.stock?.primary}
        </p>
        <p>{skus[0]?.stock?.secondary}</p>
      </div>
    );
  }

  if (selectedSku?.stock && selectedSku?.stock?.code) {
    return (
      <div data-testid="stock-message">
        <p
          className={[
            'fs-1 tvg-typography fv-heading fuse-typography-element',
            getToneClassName(selectedSku.stock.code),
          ].join(' ')}
        >
          {selectedSku?.stock?.primary}
        </p>
        <p>{selectedSku?.stock?.secondary}</p>
      </div>
    );
  }

  return null;
});

export default StockMessageDisplay;
